import React, { Fragment, useEffect } from "react";
import "./WhyJoinUs.css";
import "slick-carousel";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import $ from "jquery";

function Benefits() {
  var settings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    dots: false,
    arrows: true,
    adaptiveHeight: true,
  };
  //
  $.fn.dataImg = function (options) {
    var settings = $.extend(
      {
        sml: 400,

        med: 800,

        lrg: 1000,

        resize: false,
      },
      options,
    );

    var elements = $(this);

    function getSrc(element) {
      var screen = $(window).width();

      if (screen > settings.med) {
        return element.data("lrg");
      } else if (screen <= settings.med && screen > settings.sml) {
        return element.data("med");
      }

      return element.data("sml");
    }

    function breakpoints() {
      elements.each(function () {
        var e = $(this);

        var src = getSrc(e);

        if (src != undefined) {
          if (e.is("img")) {
            e.attr("src", src);
          } else {
            e.css("background-image", "url(" + src + ")");
          }
        }
      });
    }
    breakpoints();

    if (settings.resize === true) {
      $(window).resize(function () {
        breakpoints();
      });
    }
  };

  var plannerSliderSettings = {
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    dots: true,
    arrows: false,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  //
  // $(document).ready(function () {
  // 	$(".header-mobile-menu").click(function () {
  // 		$(".nav-wrapper").toggleClass("show-menu");
  // 	});
  // });
  $(document).ready(function () {
    // $(".header-mobile-menu").click(function () {
    // 	$(".nav-wrapper").toggleClass("show-menu");
    // });

    setTimeout(function () {
      $(".academy2").css("display", "none");
      $(".academy3").css("display", "none");
      $(".academy4").css("display", "none");
      $(".academy5").css("display", "none");
      $(".academy6").css("display", "none");
      $(".academy7").css("display", "none");
      $(".academy8").css("display", "none");
      $(".academy9").css("display", "none");
    }, 1000);

    $(".academybtncntr li").click(function () {
      $(".academybtncntr li").removeClass("active");
      $(this).addClass("active");

      if ($("#academy1").hasClass("active")) {
        $(".facilitiesslider [class^=academy]").css("display", "none");
        $(".academy1").css("display", "block");
      }
      if ($("#academy2").hasClass("active")) {
        $(".facilitiesslider [class^=academy]").css("display", "none");
        $(".academy2").css("display", "block");
      }
      if ($("#academy3").hasClass("active")) {
        $(".facilitiesslider [class^=academy]").css("display", "none");
        $(".academy3").css("display", "block");
      }
      if ($("#academy4").hasClass("active")) {
        $(".facilitiesslider [class^=academy]").css("display", "none");
        $(".academy4").css("display", "block");
      }
      if ($("#academy5").hasClass("active")) {
        $(".facilitiesslider [class^=academy]").css("display", "none");
        $(".academy5").css("display", "block");
      }
      if ($("#academy6").hasClass("active")) {
        $(".facilitiesslider [class^=academy]").css("display", "none");
        $(".academy6").css("display", "block");
      }
      if ($("#academy7").hasClass("active")) {
        $(".facilitiesslider [class^=academy]").css("display", "none");
        $(".academy7").css("display", "block");
      }
      if ($("#academy8").hasClass("active")) {
        $(".facilitiesslider [class^=academy]").css("display", "none");
        $(".academy8").css("display", "block");
      }
      if ($("#academy9").hasClass("active")) {
        $(".facilitiesslider [class^=academy]").css("display", "none");
        $(".academy9").css("display", "block");
      }
    });
  });

  $(document).ready(function () {
    $(".facilities-view1").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      // //lazyLoad: "ondemand",
    });
  });

  $(document).ready(function () {
    $(".facilities-view2").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      //lazyLoad: "ondemand",
    });
  });

  $(document).ready(function () {
    $(".facilities-view3").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      //lazyLoad: "ondemand",
    });
  });

  $(document).ready(function () {
    $(".facilities-view4").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      //lazyLoad: "ondemand",
    });
  });

  $(document).ready(function () {
    $(".facilities-view5").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      //lazyLoad: "ondemand",
    });
  });

  $(document).ready(function () {
    $(".facilities-view6").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      //lazyLoad: "ondemand",
    });
  });

  $(document).ready(function () {
    $(".facilities-view7").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      //lazyLoad: "ondemand",
    });
  });

  $(document).ready(function () {
    $(".facilities-view8").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      //lazyLoad: "ondemand",
    });
  });

  $(document).ready(function () {
    $(".facilities-view9").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
    });
  });

  return (
    <>
      <div className="main-container full_width why-join-us">
        <section className="section-masthead space-before-breadcrumb section-common-space masthead-mob-space overflow-hidden sectionnocolorbg  wju-section-1  my-0 py-0 section-container">
          <div className="container">
            <div className="row d-flex">
              <div className="col-lg-12">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <a href="/">Home</a>
                    </li>
                    <li className="breadcrumb-item d-none">
                      <a href="/work-at-jio-institute">Work at Jio Institute</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Benefits
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </section>

        <div
          data-bs-spy="scroll"
          data-bs-target="#navbar-example2"
          data-bs-offset="0"
          className="scrollspy-example"
          tabindex="0"
        >
          <section
            id="scrollspyHeading11"
            className="benefits-section section-common-space"
          >
            <div className="container">
              <h1 className="subhead-bd text-primary-n label">Benefits</h1>
              <h2>What we Offer?</h2>
              <p>
                At Jio Institute, you will find a unique opportunity to be part
                of something transformative.
              </p>
              <div className="items">
                <div className="item">
                  <h3>Make an Impact That Matters</h3>
                  <p>
                    Be part of building an institution that is redefining
                    education, research, and innovation—driving meaningful
                    impact at scale.
                  </p>
                </div>
                <div className="item">
                  <h3>Build What Doesn’t Yet Exist</h3>
                  <p>
                    At Jio Institute, you don’t just join a system—you help
                    create it. Shape academic programmes, research directions, and
                    institutional culture from the ground up.{" "}
                  </p>
                </div>
                <div className="item">
                  <h3>Where Academia Meets Industry </h3>
                  <p>
                    Work in an environment where academic excellence and
                    industry insight come together to solve real-world
                    challenges.{" "}
                  </p>
                </div>
                <div className="item">
                  <h3>Shape the Leaders of Tomorrow </h3>
                  <p>
                    Play a pivotal role in nurturing future leaders, innovators,
                    and changemakers who will influence society and the
                    economy.{" "}
                  </p>
                </div>
                <div className="item">
                  <h3>Thrive in a Future-Ready Ecosystem </h3>
                  <p>
                    Be part of a dynamic environment that embraces emerging
                    technologies and trends, preparing you to lead in a rapidly
                    evolving world.
                  </p>
                </div>
              </div>
            </div>
          </section>
          <section
            id="scrollspyHeading22"
            className="rewards-benefits-section section-common-space"
          >
            <div className="container">
              <div className="row">
                <div className="col-md-6 col-lg-4">
                  <div className="img-box">
                    <img src="/assets/images/career/commitment-to-you.jpg" alt="img" />
                  </div>
                </div>
                <div className="col-md-6 col-lg-8">
                  <h1 className="subhead-bd text-primary-n label">
                    Rewards & Benefits
                  </h1>
                  <h2>Our Commitment to You </h2>
                  <p>
                    We believe that exceptional talent deserves an enabling and
                    rewarding environment. We are committed to enabling
                    individuals who aim to perform at their highest
                    potential.{" "}
                  </p>
                  <div className="items">
                    <div className="item leadership-quality">
                      <div className="icon d-flex align-items-center justify-content-around">
                        <img
                          src="assets/images/rewards-benefits/compensation.svg"
                          alt=""
                          className="img-fluid"
                          width="100%"
                          height="auto"
                        />
                      </div>
                      <p>Competitive and performance-linked compensation</p>
                    </div>
                    <div className="item leadership-quality">
                      <div className="icon d-flex align-items-center justify-content-around">
                        <img
                          src="assets/images/rewards-benefits/research-funding.svg"
                          alt=""
                          className="img-fluid"
                          width="100%"
                          height="auto"
                        />
                      </div>
                      <p>
                        Research funding and Seed grant support (for academic
                        roles)
                      </p>
                    </div>
                    <div className="item leadership-quality">
                      <div className="icon d-flex align-items-center justify-content-around">
                        <img
                          src="assets/images/rewards-benefits/development.svg"
                          alt=""
                          className="img-fluid"
                          width="100%"
                          height="auto"
                        />
                      </div>
                      <p>Continuous learning and development opportunities</p>
                    </div>
                    <div className="item leadership-quality">
                      <div className="icon d-flex align-items-center justify-content-around">
                        <img
                          src="assets/images/rewards-benefits/wellness.svg"
                          alt=""
                          className="img-fluid"
                          width="100%"
                          height="auto"
                        />
                      </div>
                      <p>Health and wellness benefits</p>
                    </div>
                    <div className="item leadership-quality">
                      <div className="icon d-flex align-items-center justify-content-around">
                        <img
                          src="assets/images/rewards-benefits/campus.svg"
                          alt=""
                          className="img-fluid"
                          width="100%"
                          height="auto"
                        />
                      </div>
                      <p>
                        Access to world-class campus facilities (sports
                        infrastructure, gymnasium, more)
                      </p>
                    </div>
                    <div className="item leadership-quality">
                      <div className="icon d-flex align-items-center justify-content-around">
                        <img
                          src="assets/images/rewards-benefits/work-culture.svg"
                          alt=""
                          className="img-fluid"
                          width="100%"
                          height="auto"
                        />
                      </div>
                      <p>
                        A collaborative and intellectually stimulating work
                        environment
                      </p>
                    </div>
                    <div className="item leadership-quality">
                      <div className="icon d-flex align-items-center justify-content-around">
                        <img
                          src="assets/images/rewards-benefits/exposure.svg"
                          alt=""
                          className="img-fluid"
                          width="100%"
                          height="auto"
                        />
                      </div>
                      <p>
                        Opportunities for global exposure and academic
                        partnerships
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section
            id="scrollspyHeading33"
            className="benefits-section section-common-space"
          >
            <div className="container">
              <h2>
                A Campus Designed for Collaboration & Growth
              </h2>

              <div className="row">
                <div className="col-md-6 col-lg-8">
                  <p>
                    Jio Institute offers a vibrant ecosystem that supports both
                    professional excellence and personal well-being.
                  </p>
                  <p>
                    You will have access to continuous learning opportunities,
                    exposure to global best practices, and the ability to
                    contribute to impactful initiatives.
                  </p>
                  <p> Our ecosystem supports:</p>
                  <ul>
                    <li>Academic and professional development</li>
                    <li>Research and innovation initiatives</li>
                    <li>Interdisciplinary collaboration</li>
                    <li>Engagement with industry and global institutions</li>
                    <li>A vibrant and collaborative campus environment</li>
                  </ul>
                  <p>
                    We believe that our people are our greatest strength, and we
                    are committed to creating an experience that allows them to
                    thrive.
                  </p>
                </div>
                <div className="col-md-6 col-lg-4">
                  <div className="img-box">
                    <img
                      src="/assets/images/career/campus-design.jpg"
                      alt="img"
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="slider-circle-panel section-common-space overflow-hidden sectionnocolorbg hm-section-5">
            <div className="container">
              <div className="view-header">
                <h2
                  className="h2-02 font-black mb-2 heading-container-sm lh-1"
                  data-aos="fade-down"
                >
                  LIFE AT JIO INSTITUTE
                </h2>
                <p>
                  Our campus is designed to support collaboration, creativity,
                  and well-being.
                </p>
                <p>
                  With modern infrastructure, advanced facilities, and
                  thoughtfully designed spaces, we aim to create an environment
                  that enhances both professional and personal experiences.
                </p>
                <p>
                  Life at Jio Institute is enriched by a sense of community,
                  shared purpose, and opportunities for meaningful
                  engagement.{" "}
                </p>
              </div>
              <div className="facilities-slider mt-5">
                <div className="facilitiesslider">
                  <div className="academy1">
                    <div className="slick--view facilities-view1">
                      <div>
                        <img src="assets/images/Benefits/Carousel/Employee Engagement/1.png" />
                      </div>
                      <div>
                        <img src="assets/images/Benefits/Carousel/Employee Engagement/2.png" />
                      </div>
                      <div>
                        <img src="assets/images/Benefits/Carousel/Employee Engagement/3.png" />
                      </div>
                      <div>
                        <img src="assets/images/Benefits/Carousel/Employee Engagement/4.png" />
                      </div>
                    </div>
                  </div>
                  <div className="academy2">
                    <div className="slick--view facilities-view2">
                      <div>
                        <img src="assets/images/Benefits/Carousel/Festivals/5.png" />
                      </div>
                      <div>
                        <img src="assets/images/Benefits/Carousel/Festivals/6.png" />
                      </div>
                      <div>
                        <img src="assets/images/Benefits/Carousel/Festivals/7.png" />
                      </div>
                      <div>
                        <img src="assets/images/Benefits/Carousel/Festivals/8.png" />
                      </div>
                    </div>
                  </div>
                  <div className="academy3">
                    <div className="slick--view facilities-view3">
                      <div>
                        <img src="assets/images/Benefits/Carousel/Learning & Development/9.png" />
                      </div>
                      <div>
                        <img src="assets/images/Benefits/Carousel/Learning & Development/10.png" />
                      </div>
                      <div>
                        <img src="assets/images/Benefits/Carousel/Learning & Development/11.png" />
                      </div>
                      <div>
                        <img src="assets/images/Benefits/Carousel/Learning & Development/12.png" />
                      </div>
                    </div>
                  </div>
                  <div className="academy4">
                    <div className="slick--view facilities-view4">
                      <div>
                        <img src="assets/images/Benefits/Carousel/Societal Impact/13.png" />
                      </div>
                      <div>
                        <img src="assets/images/Benefits/Carousel/Societal Impact/14.png" />
                      </div>
                      <div>
                        <img src="assets/images/Benefits/Carousel/Societal Impact/15.png" />
                      </div>
                      <div>
                        <img src="assets/images/Benefits/Carousel/Societal Impact/16.png" />
                      </div>
                      <div>
                        <img src="assets/images/Benefits/Carousel/Societal Impact/17.png" />
                      </div>
                    </div>
                  </div>
                  <div className="academy7">
                    <div className="slick--view facilities-view5">
                      <div>
                        <img src="assets/images/Benefits/Carousel/Sports & Recreation/18.png" />
                      </div>
                      <div>
                        <img src="assets/images/Benefits/Carousel/Sports & Recreation/19.png" />
                      </div>
                      <div>
                        <img src="assets/images/Benefits/Carousel/Sports & Recreation/20.png" />
                      </div>
                      <div>
                        <img src="assets/images/Benefits/Carousel/Sports & Recreation/21.png" />
                      </div>
                      <div>
                        <img src="assets/images/Benefits/Carousel/Sports & Recreation/22.png" />
                      </div>
                    </div>
                  </div>
                </div>
                <ul className="academybtncntr">
                  <li className="active" id="academy1">
                    <img src="assets/images/Benefits/Carousel/Employee Engagement/1.png" />

                    <span>Employee Engagement</span>
                  </li>
                  <li className="" id="academy2">
                    <img src="assets/images/Benefits/Carousel/Festivals/5.png" />
                    <span>Festivals</span>
                  </li>
                  <li className="" id="academy3">
                    <img src="assets/images/Benefits/Carousel/Learning & Development/9.png" />
                    <span>Learning & Development</span>
                  </li>
                  <li className="" id="academy4">
                    <img src="assets/images/Benefits/Carousel/Societal Impact/13.png" />
                    <span>Societal Impact</span>
                  </li>
                  {/* <li className="" id="academy5">
							<img src="assets/images/campus-experience/dining-collaborations/faculty-dining-1.jpg" />
							<span>Dining | Collaboration</span>
						</li>
						<li className="" id="academy6">
							<img src="assets/images/campus-experience/gym/gym-Banner-1.jpg" />
							<span>Gym</span>
						</li>
						<li className="" id="academy7">
							<img src="assets/images/campus-experience/celbrations-at-ji/christmas-banner.jpg" />
							<span>Celebrations at JI</span>
						</li> */}
                  <li className="" id="academy7">
                    <img src="assets/images/Benefits/Carousel/Sports & Recreation/18.png" />
                    <span>Sports & Recreation</span>
                  </li>
                </ul>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
}

export default Benefits;
